import { render, staticRenderFns } from "./LogisticPolygons.vue?vue&type=template&id=4c4aa07a&"
import script from "./LogisticPolygons.vue?vue&type=script&lang=js&"
export * from "./LogisticPolygons.vue?vue&type=script&lang=js&"
import style0 from "./LogisticPolygons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports